//获取合同模板表格数据
export function getTableData(tableHtml, tableData, colums) {
    let rows = tableHtml.rows;
    let keys = Object.keys(tableData[0])
    let index = keys.findIndex(item => item == 'id')
    if (index != -1) {
        keys.splice(index, 1)
    }
    for (let i = 0; i < tableData.length; i++) {
        let cells = rows[i + 1].cells;
        let item = tableData[i]
        for (let j = 0; j < colums; j++) {
            if (cells[j]) {
                item[keys[j]] = cells[j]?.innerText.trim() ?? '';
                cells[j].innerHTML = item[keys[j]];
            }

        }
    }
    return tableData
}
//获取谷歌浏览器版本
function getGoogleChromeVersion() {
    const userAgent = navigator.userAgent;
    const chromeVersionRegex = /Chrome\/([\d.]+)/;
    const match = userAgent.match(chromeVersionRegex);
    return match ? match[1] : undefined;
}



//添加合同模板页码
export function addPageNum(dom, startIndex = 0, type = 'default') {
    console.log('------------------getGoogleChromeVersion()'); // 输出当前谷歌浏览器的版本号
    console.log(getGoogleChromeVersion()); // 输出当前谷歌浏览器的版本号  
    let chromeVersion = getGoogleChromeVersion()
    chromeVersion = parseInt(chromeVersion.split('.')[0])
    let no = 1011
    let positionX = 37
    if (chromeVersion <= 109) {
        no = 1010
        positionX = 37

    }
    console.log(no); // 输出当前谷歌浏览器的版本号  
    let height = dom.offsetHeight;// dom.getBoundingClientRect(). height
    // window
    // .getComputedStyle(dom)
    // .getPropertyValue("height")
    // .replace(/[^0-9\.]/gi, ""); //获取合同模板高度
    console.log('dom.getBoundingClientRect(). height')
    console.log(parseFloat(height))

    let count = Math.ceil(height / no)//(parseFloat(height) + 80) / 1012;
    console.log(count)

    switch (type) {
        case 'LaborContract':
            let subdom = document.getElementsByClassName('top_content')[0];
            let subheight = subdom.offsetHeight;
            console.log('parseFloat(subheight)')
            console.log(parseFloat(subheight))
            positionX = 38
            count = Math.ceil((height + 600) / no)
            if(parseFloat(subheight)>3860)count++
            break;
        case 'materialProcurementContract':
            count = Math.ceil((height + 60) / no)
            break;
        case 'HTMLMaterialTotalContent':
            count = Math.ceil((height) / no)
            break;
        case 'carriageContract':
            count = Math.ceil((height + 150) / no)
            break;
        case 'machinLeaseContent':
            count = Math.ceil((height + 200) / no);
            break;
        case 'concretMakeMixContent':
            count = Math.ceil((height + 480) / no);
            break;
        case 'mudMixContent':
            count = Math.ceil((height) / no);
            break;
        default:
        // count = count - 1
    }
    let sum = count - startIndex
    for (let i = 0; i < sum; i++) {
        let foot =
            '<p class="page-num" style="position:absolute;margin-top:20px;line-height:14px;top:' +
            (no * (i + startIndex + 1) + positionX * (i + startIndex)) +
            'px;right:0;font-size:12px;font-weight:400;">' +
            (i + 1) + '/' + sum
        "</p>";
        const range = document.createRange();
        // 将HTML字符串转换为DOM节点，并添加到文档片段中
        const fragment = range.createContextualFragment(foot);
        // 将文档片段添加到父元素中
        dom.appendChild(fragment);
    }
}

export function addPageNumCustom(dom, startIndex = 0, type = 'default', total, inputNo, inputPos) {
    let no = inputNo ? parseFloat(inputNo) : 1010;
    let positionX = inputPos ? parseFloat(inputPos) : 37;

    let height = dom.offsetHeight;
    let defaultCount = Math.ceil(height / no);
    console.log(defaultCount);

    switch (type) {
        case 'LaborContract':
            break;
        case 'materialProcurementContract':
            defaultCount = Math.ceil((height + 60) / no);
            break;
        case 'HTMLMaterialTotalContent':
            defaultCount = Math.ceil((height) / no);
            break;
        case 'carriageContract':
            defaultCount = Math.ceil((height + 150) / no);
            break;
        case 'machinLeaseContent':
            defaultCount = Math.ceil((height + 200) / no);
            break;
        case 'concretMakeMixContent':
            defaultCount = Math.ceil((height + 480) / no);
            break;
        case 'mudMixContent':
            defaultCount = Math.ceil((height) / no);
            break;
        default:
            break;
    }

    let count = total ? parseFloat(total) : defaultCount;

    let sum = count - startIndex;
    for (let i = 0; i < sum; i++) {
        let foot =
            '<p class="page-num" style="position:absolute;margin-top:20px;line-height:14px;top:' +
            (no * (i + startIndex + 1) + positionX * (i + startIndex)) +
            'px;right:0;font-size:12px;font-weight:400;">' +
            (i + 1) + '/' + sum
        "</p>";
        const range = document.createRange();
        // 将HTML字符串转换为DOM节点，并添加到文档片段中
        const fragment = range.createContextualFragment(foot);
        // 将文档片段添加到父元素中
        dom.appendChild(fragment);
    }
}

// '<p class="page-num" style="position:absolute;margin-top:20px;top:' +
// (267.7 * (i + startIndex + 1) + 9.58 * (i + startIndex)) +
// 'mm;right:0;font-size:12px;font-weight:400;">' +
// (i + 1) + '/' + sum
// "</p>";